import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "share-modal" }

import { ref } from "vue";
import message from "@arco-design/web-vue/es/message";
import API from "@/api";
import {
  addOjJudgecaseUsingPost,
  getOjJudgecaseByIdUsingGet,
  updateOjJudgecaseUsingPost,
} from "@/api/ojJudgecaseController";
/**
 * 定义组件属性类型
 */
interface Props {
  questionId: string;
}

/**
 * 给组件指定初始值
 */
// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'AddOjJudgeCaseModal',
  props: {
    questionId: { default: () => "" }
  },
  emits: ["updateData"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const id = ref("");
const visible = ref(false);

const openModal = (ojJudgeCaseId: any) => {
  id.value = ojJudgeCaseId;
  loadData();
  visible.value = true;
};

const closeModal = () => {
  visible.value = false;
};

__expose({
  openModal,
});

const oldOjJudgeCase = ref<API.OjJudgecaseVO>({});
/**
 * 加载数据
 */
const loadData = async () => {
  if (!id.value || id.value === "") {
    oldOjJudgeCase.value = {};
    return;
  }
  const res = await getOjJudgecaseByIdUsingGet({ id: id.value as any });
  if (res.data.code === 200 && res.data.data) {
    oldOjJudgeCase.value = res.data.data;
  } else {
    message.error("获取数据失败，" + res.data.message);
  }
};

const emit = __emit;

const handleOk = async () => {
  // 如果是修改
  if (id.value !== "") {
    const res = await updateOjJudgecaseUsingPost({
      id: id.value as any,
      ...oldOjJudgeCase.value,
    });
    if (res.data.code === 200) {
      closeModal();
      message.success("修改成功");
    } else {
      message.error("修改失败，" + res.data.message);
    }
  } else {
    // 创建
    const res = await addOjJudgecaseUsingPost({
      ...oldOjJudgeCase.value,
      questionId: props.questionId as any,
    });
    if (res.data.code === 200) {
      message.success("添加成功");
      closeModal();
    } else {
      message.error("添加失败，" + res.data.message);
    }
  }
  emit("updateData");
};

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_modal, {
      visible: visible.value,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((visible).value = $event)),
      onCancel: closeModal,
      onOk: handleOk,
      width: "auto"
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(id.value === "" || id.value === null ? "添加用例" : "修改用例"), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: oldOjJudgeCase.value,
          style: { width: '600px' }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "输入" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  modelValue: oldOjJudgeCase.value.input,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((oldOjJudgeCase.value.input) = $event)),
                  placeholder: "请输入输入"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "输出" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  modelValue: oldOjJudgeCase.value.output,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((oldOjJudgeCase.value.output) = $event)),
                  placeholder: "请输入输出"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})